module.exports = __webpack_public_path__ + "img/ic_food_night.c3aea77e.png";